import { render, staticRenderFns } from "./UiFormTextarea.vue?vue&type=template&id=7b7eb19f&"
import script from "./UiFormTextarea.vue?vue&type=script&lang=js&"
export * from "./UiFormTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports